import React, { useState } from "react";
import axios from '../../../api/axios';
import { sendMessageToReactNativeApp } from "../../../components/utils/sendMessageToReactNativeApp";
import { useNavigate } from "react-router-dom";

interface FeedbackScreenProps {
  doctorId: string;
  teleconsultId: string;
  visible: boolean;
  onClose: () => void;
  token: string | undefined | null;
  patientId: string;
  teleconsultationCode: string;
}

const FeedbackModal: React.FC<FeedbackScreenProps> = ({
  doctorId,
  teleconsultId,
  patientId,
  token,
  visible,
  onClose,
  teleconsultationCode
}) => {
  const [reviewDate, setReviewDate] = useState(new Date().toISOString());
  const [review, setReview] = useState("");
  const [hideName, setHideName] = useState(false);
  const [rating, setRating] = useState(0);
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const navigate = useNavigate()

  const tags = [
    "Respon Cepat",
    "Dokter Ramah",
    "Diagnosis Tepat",
    "Berpengalaman",
    "Penjelasan Mudah Dimengerti",
  ];

  const handleTagToggle = (tag: string) => {
    if (selectedTags.includes(tag)) {
      setSelectedTags(selectedTags.filter((t) => t !== tag));
    } else {
      setSelectedTags([...selectedTags, tag]);
    }
  };

  const handleSubmit = async (e?: React.FormEvent) => {
    if (e) e.preventDefault();
    try {
      const payload = {
        practitionerId: doctorId,
        patientId,
        consultationId: teleconsultId,
        reviewDate,
        amountLike: rating,
        description: review,
        showPatient: hideName ? 0 : 1, // 0 = hide name, 1 = show name
        tags: selectedTags.join(","),
      };
      await axios.post('/rating', payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      navigate('/home')
      onClose();
    } catch (error) {
      console.error('Failed to send feedback:', error);
    }
  };



  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[999] flex items-end justify-center bg-black bg-opacity-40">
      <div className="w-full max-w-md p-6 bg-white rounded-t-2xl shadow-lg">
        <h2 className="text-lg font-semibold text-center mb-2">Konsultasi Selesai</h2>

        {/* Box untuk judul dan rating */}
        <div
          className="flex flex-col items-center text-center mb-4"
          style={{
            backgroundColor: "#f8f8f8",
            borderRadius: "12px",
            padding: "10px",
          }}
        >
          <p className="text-sm text-gray-600 mb-4">
            Beri ulasan untuk sesi konsultasi ini
          </p>

          <div className="flex">
            {[1, 2, 3, 4, 5].map((star) => (
              <img
                key={star}
                src={rating >= star ? "/icons/start-filled.svg" : "/icons/start.svg"}
                alt={`Bintang ${star}`}
                className="w-6 h-6 cursor-pointer"
                style={{ marginRight: star < 5 ? "10px" : "0" }}
                onClick={() => setRating(star)}
              />
            ))}
          </div>
        </div>

        <div className="flex flex-col">
          {rating > 0 && (
            <>
              <h2 className="text-sm font-medium mb-2">
                Apa yang bagus dari konsultasi ini?
              </h2>

              {/* Tags */}
              <div className="flex flex-wrap gap-2 mb-4">
                {tags.map((tag) => {
                  const isSelected = selectedTags.includes(tag);
                  return (
                    <button
                      key={tag}
                      onClick={() => handleTagToggle(tag)}
                      className={`text-sm px-3 py-1 rounded-full border transition ${isSelected
                        ? "bg-teal-500 text-white border-teal-500"
                        : "text-teal-500 border-teal-500 bg-white"
                        }`}
                    >
                      {tag}
                    </button>
                  );
                })}
              </div>

              {/* Textarea */}
              <div className="w-full mb-1">
                <textarea
                  style={{ backgroundColor: "#f8f8f8" }}
                  value={review}
                  onChange={(e) => setReview(e.target.value)}
                  maxLength={250}
                  placeholder="Tulis Ulasan (Opsional)"
                  className="w-full p-3 text-sm border border-gray-300 rounded-md resize-none focus:outline-none focus:ring-1 focus:ring-red-500"
                  rows={3}
                />
              </div>
              <div className="w-full text-left text-xs text-gray-400 mb-4">
                {review.length}/250 karakter
              </div>

              {/* Switch */}
              <div className="flex items-center w-full mb-6">
                <label className="flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={hideName}
                    onChange={(e) => setHideName(e.target.checked)}
                    className="sr-only"
                  />
                  <div
                    className={`w-10 h-5 flex items-center rounded-full p-1 duration-300 ease-in-out ${hideName ? "bg-red-500" : "bg-gray-300"
                      }`}
                  >
                    <div
                      className={`bg-white w-4 h-4 rounded-full shadow-md transform duration-300 ease-in-out ${hideName ? "translate-x-5" : "translate-x-0"
                        }`}
                    />
                  </div>
                  <span className="ml-3 text-sm text-gray-600">
                    Sembunyikan nama saya dari ulasan
                  </span>
                </label>
              </div>
            </>
          )}

          {/* Tombol Kirim */}
          <button
            onClick={(e) => {
              if (rating === 0) {
                navigate('/home')
                // onClose();
              } else {
                handleSubmit(e);
              }
            }}
            className={`bg-teal-500 hover:bg-teal-600 text-white font-semibold w-full py-3 rounded-full transition duration-200`}
          >
            {rating === 0 ? "Lewati" : "Kirim"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;
